// Stable "download the latest macOS app" URL. The marketing site's
// `/download/mac` endpoint 302-redirects to the newest signed DMG in R2 — the
// SAME mechanism the home page's download button uses — so this always resolves
// to the current release (no version pinning here). Previously this pointed at
// the bare landing page (`https://ano.dev`), which just showed the home page
// instead of starting a download. macOS builds are Apple-Silicon (arm64) only.
export const DESKTOP_DOWNLOAD_URL = "https://ano.chat/download/mac";

// TestFlight preview link for the iOS app. The QR asset
// (`@/assets/ios-testflight-qr.svg`) encodes THIS exact URL — regenerate it
// (`npx qrcode -t svg -o … "<url>"`) if it ever changes. Single source for both
// the Inbox "Get the iOS app" card and the "Get the apps" dialog.
export const IOS_TESTFLIGHT_URL = "https://testflight.apple.com/join/NPmQq6qU";

/**
 * Start downloading the latest Ano desktop app (macOS DMG). In Electron we route
 * through `openExternalUrl` so the click opens in the system browser (which then
 * downloads the DMG) instead of navigating inside the Electron window.
 */
export function openDesktopDownload(): void {
  const api = (
    window as unknown as {
      __electronApi?: { openExternalUrl?: (u: string) => Promise<unknown> };
    }
  ).__electronApi;
  if (api?.openExternalUrl) {
    void api.openExternalUrl(DESKTOP_DOWNLOAD_URL);
  } else {
    window.open(DESKTOP_DOWNLOAD_URL, "_blank", "noopener,noreferrer");
  }
}
